
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftBottom0 as ObiThreewayAcuatorPistonInleftBottom0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-bottom-0.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftBottom0 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-bottom-0',
   elementClass: ObiThreewayAcuatorPistonInleftBottom0Element,
   events: {
     
   }
  });
 
 